import { BrandLogo } from '@/components/shared/BrandLogo';

/** Branding block at the top of the login card (US-001 AC-001). */
export function LoginIntro(): React.JSX.Element {
  return (
    <>
      <BrandLogo className="mx-auto mb-8 h-20" />

      <div className="text-center">
        <h1 className="text-brand-600 text-2xl font-bold tracking-tight">Provider Portal</h1>
        <p className="text-muted mt-2.5 text-sm">
          Enter your Provider ID to access policy and claims tools.
        </p>
      </div>
    </>
  );
}
